import { throttle } from 'lodash';
import constants from './constant';
import { saveStoreToStorage } from './sessionStorageHandler';
import { Store } from '@reduxjs/toolkit';

export const subscribe = (reduxStore: Store) => {
    reduxStore.subscribe(throttle(() => {
        saveStoreToStorage({
            ...reduxStore.getState()
        });
    }, constants.STORE_TIME_OUT));
    return reduxStore;
};
